import { FileText, ExternalLink, Edit, Crown } from "lucide-react";

interface SalepageCoursesProps {
  allSalepages: any[];
}

export default function SalepageCourses({ allSalepages }: SalepageCoursesProps) {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
        <FileText className="w-6 h-6 text-emerald-600" />
        Salepage ทั้งหมด ({allSalepages.length})
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {allSalepages.length > 0 ? (
          allSalepages.map((salepage, index) => {
            const salePageUrl = salepage.customDomain 
              ? `https://${salepage.customDomain}` 
              : `https://saledi.web.app/${salepage.username}`;
            
            return (
              <div key={index} className="border border-gray-200 rounded-xl p-5 hover:shadow-lg transition-shadow">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex-1">
                    <h3 className="font-bold text-gray-900 mb-1">{salepage.title || 'ไม่มีชื่อ'}</h3>
                    <p className="text-sm text-gray-500 break-all">{salepage.username}</p>
                  </div>
                </div>
                
                {salepage.customDomain && (
                  <div className="mb-3">
                    <span className="inline-flex items-center gap-1 px-2 py-1 bg-purple-100 text-purple-700 rounded-lg text-xs font-medium">
                      <Crown className="w-3 h-3" />
                      Custom Domain
                    </span>
                  </div>
                )}

                <div className="flex gap-2">
                  <a
                    href={salePageUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg text-sm font-medium transition-colors"
                  >
                    <ExternalLink className="w-4 h-4" />
                    เปิด
                  </a>
                  <a
                    href={`/salepage/dashboard?id=${salepage.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg text-sm font-medium transition-colors"
                  >
                    <Edit className="w-4 h-4" />
                    แก้ไข
                  </a>
                </div>
              </div>
            );
          })
        ) : (
          <div className="col-span-full text-center text-gray-500 py-12">
            <FileText className="w-16 h-16 mx-auto mb-4 text-gray-300" />
            <p>ยังไม่มี Salepage</p>
          </div>
        )}
      </div>
    </div>
  );
}
